<!--
 * @Author: Lsuihua Lsuihua_email@163.com
 * @Date: 2023-11-21 09:31:17
 * @LastEditors: Lsuihua Lsuihua_email@163.com
 * @LastEditTime: 2023-12-09 10:53:34
 * @FilePath: \internation-live-web\src\App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <home-index />
</template>

<script>
import homeIndex from "@/views/home/index.vue";
export default {
  name: "App",
  components: {
    homeIndex,
  },
  mounted() {
    let token;
    // const kjToken = localStorage.getItem("kjLiveToken");
    document.cookie.split(";").forEach(function (item) {
      const arr = item.split("=");
      if (arr[0].trim() === "kjLiveToken") {
        token = arr[1];
      }
    });
    if (token) {
      location.href = "/zhibo/";
    }
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #333333;
}
</style>
